module.exports = __webpack_public_path__ + "img/patient_secondary.9332a344.svg";